import { RemoteCreateNewRoute } from '@/javascript/data/usecases/maps/remote-create-new-route'
import { CreateNewRoute } from '@/javascript/domain/usecases/maps/create-new-route'
import { makeApiUrl, makeAxiosHttpClient } from '@/javascript/main/factories/http'

export const makeRemoteCreateNewRoute = (): CreateNewRoute =>
  new RemoteCreateNewRoute(makeApiUrl('/maps/routes'), makeAxiosHttpClient())
